import { ref } from 'vue'

// 创建全局事件总线
class EventBus {
  constructor() {
    this.events = {}
  }

  // 监听事件
  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = []
    }
    this.events[event].push(callback)
  }

  // 移除事件监听
  off(event, callback) {
    if (!this.events[event]) return
    
    if (callback) {
      this.events[event] = this.events[event].filter(cb => cb !== callback)
    } else {
      delete this.events[event]
    }
  }

  // 触发事件
  emit(event, data) {
    if (!this.events[event]) return
    
    this.events[event].forEach(callback => {
      callback(data)
    })
  }

  // 清除所有事件
  clear() {
    this.events = {}
  }
}

// 创建全局实例
export const eventBus = new EventBus()

// 导出事件名称常量
export const EVENTS = {
  TICKET_NOTIFICATION_RECEIVED: 'ticket_notification_received',
  REFRESH_TICKET_LIST: 'refresh_ticket_list',
  NOTIFICATION_READ: 'notification_read',
  NOTIFICATION_DELETED: 'notification_deleted'
}